import computed from './view_job_profile_computed';
import drawer_methods from './view_job_profile_drawer_methods';
import api_methods from './view_job_profile_api_methods';
import normalize_methods from './view_job_profile_normalize_methods';
import extract_methods from './view_job_profile_extract_methods';
import section_methods from './view_job_profile_section_methods';
import editor_methods from './view_job_profile_editor_methods';
import save_methods from './view_job_profile_save_methods';

export default {
  computed,
  methods: {
    ...drawer_methods,
    ...api_methods,
    ...normalize_methods,
    ...extract_methods,
    ...section_methods,
    ...editor_methods,
    ...save_methods,
  },
  beforeUnmount() {
    this.cleanup_editors();
  },
};

